import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { ParallaxProvider } from 'react-scroll-parallax'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

import Header from '../Header'
import Footer from '../Footer'
import MobileNavigation from '../MobileNavigation'

import { StyledLayout } from './styles.js'
import Fonts from './../../utils/fonts'
import normalize from './../../styles/normalize.css'
import { Breakpoints } from '../../utils/variables';

class Layout extends React.Component {

	constructor(props) {

		library.add(fas)

		super(props)

		this.state = {
			isMobile: (typeof window !== 'undefined') ? window.innerWidth < 1024 : Breakpoints.wide,
			mobileActive: false
		}
	}

	componentDidMount() {
	
		window.addEventListener('resize', this.resizeHandler)

	}

	componentWillUnmount() {

		window.removeEventListener('resize', this.resizeHandler)

	}

	resizeHandler = () => {

		const isMobile = window.innerWidth < 1024

		if (isMobile !== this.state.isMobile) {
			this.setState({ isMobile })
		}

	}

	onClickHandler = () => {
		
		this.setState({
			mobileActive: !this.state.mobileActive
		})

	}

	render() {
		return (
			<ParallaxProvider>
			<StaticQuery
				query={graphql`
					query SiteTitleQuery {
						site {
							siteMetadata {
								title
							}
						}
					}
				`}
				render={data => (
				<>
					<Fonts />
					
					<Header 
						siteTitle={data.site.siteMetadata.title} 
						theme={this.props.theme} 
						isMobile={this.state.isMobile}
						onClick={this.onClickHandler} 
						active={this.state.mobileActive}
						page={this.props.page}
					/>

					{this.state.isMobile ? <MobileNavigation active={this.state.mobileActive} /> : null }

					<StyledLayout page={this.props.page}>
						{this.props.children}
					</StyledLayout>

					<Footer />
				</>
				)}
			/>
			</ParallaxProvider>
		)
	}

}

export default Layout
